// Blog registry. Each post lives in ./posts/<slug>/ with a meta.json (read by the
// app, the prerender/sitemap script and the preview image generator) and a
// Content.jsx body. To add a post, create that folder and add it below.
import blenderReduceGlbFileSizeMeta from './posts/blender-reduce-glb-file-size/meta.json';
import BlenderReduceGlbFileSize from './posts/blender-reduce-glb-file-size/Content';
import dracoCompressionMeta from './posts/draco-compression/meta.json';
import DracoCompression from './posts/draco-compression/Content';
import dracoVsMeshoptMeta from './posts/draco-vs-meshopt/meta.json';
import DracoVsMeshopt from './posts/draco-vs-meshopt/Content';
import gltfTransformOptimizeMeta from './posts/gltf-transform-optimize/meta.json';
import GltfTransformOptimize from './posts/gltf-transform-optimize/Content';
import gltfVsGlbMeta from './posts/gltf-vs-glb/meta.json';
import GltfVsGlb from './posts/gltf-vs-glb/Content';
import reduceGlbFileSizeMeta from './posts/reduce-glb-file-size/meta.json';
import ReduceGlbFileSize from './posts/reduce-glb-file-size/Content';
import shopify3dModelsMeta from './posts/shopify-3d-models/meta.json';
import Shopify3dModels from './posts/shopify-3d-models/Content';
import threejsLoadGlbMeta from './posts/threejs-load-glb/meta.json';
import ThreejsLoadGlb from './posts/threejs-load-glb/Content';
import whatIsAGlbFileMeta from './posts/what-is-a-glb-file/meta.json';
import WhatIsAGlbFile from './posts/what-is-a-glb-file/Content';

const entries = [
  [blenderReduceGlbFileSizeMeta, BlenderReduceGlbFileSize],
  [dracoCompressionMeta, DracoCompression],
  [dracoVsMeshoptMeta, DracoVsMeshopt],
  [gltfTransformOptimizeMeta, GltfTransformOptimize],
  [gltfVsGlbMeta, GltfVsGlb],
  [reduceGlbFileSizeMeta, ReduceGlbFileSize],
  [shopify3dModelsMeta, Shopify3dModels],
  [threejsLoadGlbMeta, ThreejsLoadGlb],
  [whatIsAGlbFileMeta, WhatIsAGlbFile],
];

export const blogPosts = entries
  .map(([meta, Content]) => ({ ...meta, Content, image: `/images/og/blog/${meta.slug}.png` }))
  .sort((a, b) => b.datePublished.localeCompare(a.datePublished));

export const getPost = (slug) => blogPosts.find((post) => post.slug === slug);

// Posts sharing the most tags first, then newest.
export function getRelatedPosts(post, count = 3) {
  return blogPosts
    .filter((other) => other.slug !== post.slug)
    .map((other) => ({ other, score: other.tags.filter((tag) => post.tags.includes(tag)).length }))
    .sort((a, b) => b.score - a.score || b.other.datePublished.localeCompare(a.other.datePublished))
    .slice(0, count)
    .map(({ other }) => other);
}
